import React from "react";
import { Col, ListGroupItem, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa";

const PatientListItem = ({ patient, clinicId, reqDate }) => {
  const navigate = useNavigate();
  return (
    <div>
      <ListGroupItem
        onClick={() =>
          navigate(
            `/patient-screen/${patient._id}?clinicId=${clinicId}&reqDate=${reqDate}`,
          )
        }
        className="d-flex my-2 justify-content-between align-items-center border-primary"
      >
        <Col>
          <Row className="justify-content-center">
            <h3 className="row flex-row-reverse">
              <span className="left-text">
                {`${patient.firstName} ${patient.secondName} ${patient.thirdName} ${patient.fourthName}`}
              </span>
            </h3>
            <br />{" "}
          </Row>
          <Row>
            <Col className="text-center">
              <h4>تاريخ الميلاد: {patient.birthdate?.substring(0, 10)}</h4>
            </Col>
          </Row>

          <Row>
            <Col className="text-right">
              <div className="btn btn-outline-primary">
                <FaExternalLinkAlt /> Go
              </div>
            </Col>
          </Row>
        </Col>
      </ListGroupItem>
    </div>
  );
};

export default PatientListItem;
